import React, { forwardRef } from "react";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import classNames from "classnames";

export interface IContactInfoProps extends IStyledProps, IEditableProps {
    title: string;
    name: string;
    phone: string;
    fax?: string;
    email: string;
    nmls?: string;
}

const ContactInfo = forwardRef((props: IContactInfoProps, ref: any) => {
    const { title, name, phone, fax, email, nmls, className, editorClassObj, cmsId } = props;

    function formatPhoneNumber(phoneNumberString) {
        const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

        if (match) {
            return match[1] + "-" + match[2] + "-" + match[3];
        }

        return null;
    }

    return (
        <div ref={ref} data-id={cmsId} className={classNames(className, editorClassObj)}>
            <div className="mb-3">
                <h2 className="business-card-title text-serif text-muted">{title}</h2>
                <h3 className="text-dark mt-1 text-sans font-weight-bold">{name}</h3>
            </div>
            <div className="mt-3">
                {phone &&
                    <div className="font-weight-bold mb-2 h5">
                        <a className="text-dark text-decoration-none contact-work-phone" href={`tel:${phone}`}>{formatPhoneNumber(phone)}</a>
                    </div>
                }
                {fax &&
                    <div className="font-weight-bold mb-2 h5">
                        <a className="text-dark text-decoration-none contact-fax-number" href={`tel:${fax}`}>{formatPhoneNumber(fax)} (Fax)</a>
                    </div>
                }
                {email &&
                    <div className="mb-2">
                        <a className="text-dark arrow text-decoration-none contact-email" href={`mailto: ${email}`}>{email}</a>
                    </div>
                }
                {nmls &&
                    <div className="contact-nmls">NMLS#: {nmls}</div>
                }
            </div>
        </div>
    );
});

export default ContactInfo;
(global as any).ContactInfo = ContactInfo;